import { useEffect, useState } from "react";
import { browserStorage } from "~/libs/localforage";
import { initialState, MultiSelectButtonContext, MultiSelectButtonState, MultiSelectMode } from "./multi-select-button-context";
import type { FC, ReactNode } from "react";
interface MultiSelectButtonProviderProps {
  children?: ReactNode;
}
export const MultiSelectButtonProvider: FC<MultiSelectButtonProviderProps> = props => {
  const {
    children
  } = props;
  const [state, setState] = useState<MultiSelectButtonState>(initialState);
  useEffect(() => {
    browserStorage.multiSelectButton.get().then(r => {
      setState(r ? JSON.parse(r) : initialState);
    }).catch(err => console.log({
      err
    }));
  }, []);
  const handleSelectFile = async (selectedId: string) => {
    const isAlreadySelected = state.selectedFiles ? state.selectedFiles.find(id => id === selectedId) : false;
    const seletedFiles = isAlreadySelected ? state.selectedFiles?.filter(id => id !== selectedId) : [...(state.selectedFiles ?? []), selectedId];
    await browserStorage.multiSelectButton.set(JSON.stringify({
      ...state,
      selectedFiles: seletedFiles
    }));
    setState({
      ...state,
      selectedFiles: seletedFiles
    });
  };
  const handleSetAllSelectedFile = async (selectedFileIds: string[]) => {
    await browserStorage.multiSelectButton.set(JSON.stringify({
      ...state,
      selectedFiles: selectedFileIds ?? []
    }));
    setState({
      ...state,
      selectedFiles: selectedFileIds ?? []
    });
  };
  const handleMultiSelectButtonOpen = async (mode: MultiSelectMode) => {
    await browserStorage.multiSelectButton.set(JSON.stringify({
      ...state,
      mode: mode,
      isOpen: true
    }));
    setState({
      ...state,
      mode: mode,
      isOpen: true
    });
  };
  const handleMultiSelectButtonClose = async () => {
    await browserStorage.multiSelectButton.set(JSON.stringify({
      ...state,
      isOpen: false,
      isCreating: false,
      mode: undefined,
      selectedFiles: []
    }));
    setState({
      ...state,
      isOpen: false,
      isCreating: false,
      mode: undefined,
      selectedFiles: []
    });
  };
  const handleMultiSelectButtonOnCreate = async () => {
    await browserStorage.multiSelectButton.set(JSON.stringify({
      ...state,
      isOpen: false,
      isCreating: true
    }));
    setState({
      ...state,
      isOpen: false,
      isCreating: true
    });
  };
  return <MultiSelectButtonContext.Provider value={{
    ...state,
    handleMultiSelectButtonClose,
    handleMultiSelectButtonOpen,
    handleMultiSelectButtonOnCreate,
    handleSelectFile,
    handleSetAllSelectedFile
  }} data-sentry-element="unknown" data-sentry-component="MultiSelectButtonProvider" data-sentry-source-file="multi-select-button-provider.tsx">
			{children}
		</MultiSelectButtonContext.Provider>;
};